module.exports = __webpack_public_path__ + "static/media/petitioner_simple_plus.739b04d9.pdf";